// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2sEzX","header":"PatientQuestionnaire_header__3tqcF","info":"PatientQuestionnaire_info___A-gs"};